export type SignalviewFeatureFlag = 'newRbacExperience' | 'accessControl' | 'enableSamlLogs';

export type EnabledFeature = (featureKey: SignalviewFeatureFlag) => boolean;

export type FeatureFlags = Partial<Record<SignalviewFeatureFlag, boolean>>;

export function createFeatureEnabled(featureFlags?: FeatureFlags): EnabledFeature {
    return (featureKey: SignalviewFeatureFlag): boolean => {
        try {
            return Boolean(featureFlags?.[featureKey]);
        } catch (error) {
            if (error instanceof Error && error.message === 'Proxy Not Found: featureFlags') {
                return false;
            }
            throw error;
        }
    };
}
